import React from "react";

import axios from "axios";
import classNames from "classnames";
import { useQuery, UseQueryResult } from "react-query";

const getHealthCheckUri = (apiUrl?: string) => {
  if (apiUrl == null) return "";
  return `${apiUrl.replace(/\/admin(?:\/v\d+)?/, "")}/ht`;
};

const healthChecks = [
  {
    label: "common-server",
    queryKey: ["health-check", "common-api"],
    queryFn: async () => await axios.get(getHealthCheckUri(process.env.REACT_APP_SUPERCLUB_COMMON_ADMIN_URL)),
  },

  {
    label: "club-server",
    queryKey: ["health-check", "club-api"],
    queryFn: async () => await axios.get(getHealthCheckUri(process.env.REACT_APP_SUPERCLUB_CLUB_ADMIN_URL)),
  },

  {
    label: "sns-server",
    queryKey: ["health-check", "sns-api"],
    queryFn: async () => await axios.get(getHealthCheckUri(process.env.REACT_APP_SUPERCLUB_SNS_ADMIN_URL)),
  },

  {
    label: "post-server",
    queryKey: ["health-check", "post-api"],
    queryFn: async () => await axios.get(getHealthCheckUri(process.env.REACT_APP_SUPERCLUB_POST_ADMIN_URL)),
  },

  {
    label: "vote-server",
    queryKey: ["health-check", "vote-api"],
    queryFn: async () => await axios.get(getHealthCheckUri(process.env.REACT_APP_SUPERCLUB_VOTE_ADMIN_URL)),
  },
] as const;

const HealthCheck = () => {
  const queries = healthChecks.map((check) => useQuery<any, unknown>(check.queryKey, check.queryFn));

  return (
    <div className="fixed inset-0 z-50 flex flex-col p-10 text-[20px]">
      <h1 className="mb-5 font-bold">HealthCheck</h1>

      <ul className="flex flex-col gap-2 text-[16px]">
        {healthChecks.map((check, index) => (
          <HealthCheckItem key={check.label} label={check.label} query={queries[index]} />
        ))}
      </ul>
    </div>
  );
};

export default HealthCheck;

const HealthCheckItem = ({ label, query }: { label: string; query: UseQueryResult<any, unknown> }) => {
  return (
    <li>
      <span>{label}: </span>
      <span
        className={classNames({
          "text-error-100": query.isError,
          "text-success-100": query.isSuccess,
          "text-warning-100": query.isFetching,
        })}
      >
        {query.isFetching ? "LOADING" : query.isSuccess ? "OK" : `ERROR: ${String(query.error)}`}
      </span>
    </li>
  );
};
